import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import routes from "../../engine/routes";
import { getTitleByCustomer } from "../../engine/customerConfig";
import { Outlet } from "react-router-dom";
import {
  renderTitle,
  RenderTitle,
} from "../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";
import { t } from "i18next";

// Helper function to check if a path matches, considering dynamic segments
const matchRoute = (routePath, currentPath) => {
  // Split the route and current path into segments
  const routeSegments = routePath.split("/").filter(Boolean);
  const currentSegments = currentPath.split("/").filter(Boolean);

  // Check if the number of segments (i.e., levels) match
  if (routeSegments.length !== currentSegments.length) {
    return false; // If the levels don't match, return false
  }

  // Check if each segment matches or is a dynamic segment
  return routeSegments.every((segment, i) => {
    return segment.startsWith(":") || segment === currentSegments[i];
  });
};

function DynamicHelmet({ children }) {
  const location = useLocation();
  const reduxState = useSelector(state => state);

  const renderMainTitle = ressource => {
    switch (ressource) {
      case routes.prestations().path:
        const { prestation } = reduxState?.prestation;

        return `${t("prestation")} ${prestation.reference} - ${prestation
          .institution?.name || ""}`;
    }
  };

  // Function to find the correct route title
  const findRouteTitle = (currentPath, routesConfig) => {
    for (const key in routesConfig) {
      const route = routesConfig[key];

      if (typeof route === "function") {
        const routeObject = route();

        for (const keyRoute in routeObject) {
          const itemRoute = routeObject[keyRoute];

          if (itemRoute.path !== undefined) {
            let isMatch = matchRoute(itemRoute.path, currentPath);

            // IF

            if (isMatch) {
              // IF is function
              if (typeof itemRoute.title === "function") {
                return renderMainTitle(routeObject.path);

                // if (routeObject.mainTitle !== undefined) {
                //   let u = routeObject.mainTitle();
                // }

                // let test = renderTitle({ title: itemRoute.title });
                return "";
              } else {
                return itemRoute.title;
              }
            }
          }

          // NEXT IS SUB SUB ROUTES
          if (typeof itemRoute === "function") {
            let routeDeclaration = itemRoute();
            if (routeDeclaration.path !== undefined) {
            }
          }
        }

        // if (
        //   routeObject.path !== undefined &&
        //   matchRoute(routeObject.path, currentPath)
        // ) {
        //   return routeObject.title;
        // }
        //
        // // Check nested routes
        // for (const subRouteKey in routeObject) {
        //   const subRoute = routeObject[subRouteKey];
        //   if (
        //     subRoute &&
        //     typeof subRoute === "object" &&
        //     subRoute.path &&
        //     matchRoute(subRoute.path, currentPath)
        //   ) {
        //     return subRoute.title;
        //   }
        // }
      }
    }

    return "Default Title"; // Fallback title if no match is found
  };
  const pageTitle =
    findRouteTitle(location.pathname, routes) || "Default Title";

  return (
    <>
      <Helmet>
        <title>{`${getTitleByCustomer()} - ${pageTitle}`}</title>
        <meta name="description" content={getTitleByCustomer()} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`${pageTitle} - ${getTitleByCustomer()}`}
        />
        <meta property="og:description" content={getTitleByCustomer()} />
      </Helmet>
      <Outlet></Outlet>
    </>
  );
}

export default DynamicHelmet;
